// Copyright (c) 2019-24 Stax·ai, Inc.
// See LICENSE.md file in project root directory

import React from 'react';
import { toast } from 'react-toastify';
import { withRouter } from 'react-router-dom';

import api from '../api';
import passwordStrength from '../utilities/passwordStrength';

import '../styles/start.css';

class SetPassword extends React.Component {

    state = {

        // Animation
        stage: 0,
        visible: false,

        // Submit variables
        password: ""
    }

    componentDidMount = () => {
        // DEV
        // return this.setState({ stage: 3, visible: true });
        setTimeout(() => this.setState({
            stage: 1,
            visible: true
        }), 500);
        setTimeout(() => this.nextStage(null, 2), 3000);
        setTimeout(() => this.nextStage(null, 3), 8000);
    }

    nextStage = (e, stage) => {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
        this.setState({ visible: false });
        setTimeout(() => this.setState({
            stage: stage ? stage : this.state.stage+1,
            visible: true
        }), 700);
    }

    setPassword = async () => {
        this.nextStage(null, 4);

        // Create account and auto-login
        const res = await api.post('/user/setPassword', {
            userId: this.props.match.params.userId,
            resetToken: this.props.match.params.resetToken,
            password: this.state.password
        });

        if (!res || !res.success) {
            toast.error("Oops! Something went wrong!");
            return this.nextStage(null, 3); // Return to try again
        }

        // If successful, the API sets user cookies, we can go forward to login! :)
        setTimeout(() => this.nextStage(null, 5), 1000);
        setTimeout(() => window.location.href = "/login", 4000);
    }

    render = () => {
        document.title = "Reset your password | Stax·ai";

        const pass = passwordStrength(this.state.password);
        return (<div className="start-container">
            <div className={"start-content" + (!this.state.visible ? " start-content-hidden" : "")}>

                {/* Hi */}
                {this.state.stage === 1 ? <>
                    <h2>Sorry you forgot your password!</h2>
                </> :
                
                // User name
                this.state.stage === 2 ? <>
                    <h2>Make sure you set a secure and memorable<br />password this time...</h2>
                </> :
                
                // Password
                this.state.stage === 3 ? <>
                    <h1>Create a new password</h1>
                    <form onSubmit={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        if (this.state.password === "")
                            return;
                        if (pass !== "ok")
                            return toast.error("Your password is not strong enough.");
                        this.setPassword();
                    }}>
                        <input
                            ref="password"
                            id="password"
                            name="password"
                            type="password"
                            placeholder="Enter a secure password..."
                            value={this.state.password}
                            onChange={e => this.setState({ password: e.target.value })}
                            autoComplete="off"
                            autoFocus
                        />
                        {this.state.visible && pass === "ok" && <input
                            type="submit"
                            value=""
                            title="Next"
                            readOnly={true}
                        />}
                    </form>
                    <div className="start-content-hint">
                        {this.state.password !== "" ? (pass === "ok" ? <>
                            <img
                                src="https://static.stax.ai/images/icons/reviewed.png"
                                alt="Available"
                            />Awesome, that's a strong password!
                        </> : <>
                            <img
                                src="https://static.stax.ai/images/icons/alert.png"
                                alt="Unavailable"
                            />{pass}
                        </>) : ""}
                    </div>
                    <div className="start-content-fixed-message">
                        By creating an account, you agree to the <a href="https://stax.ai/license">Stax·ai Terms of Service</a>.
                    </div>
                </> :

                // Creating...
                this.state.stage === 4 ? <>
                    <h1>Securing your account...</h1>
                </> :
                
                // Account created!
                this.state.stage === 5 ? <>
                    <h1>That's it, you're all set!</h1>
                    <div className="start-content-line" />
                    <h2>You can now log in to STAX<div className="navigation-logo-dot"></div>AI!</h2>
                </> : ""}

            </div>
        </div>);
    }

};

export default withRouter(SetPassword);